// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_cx-2";
export var aiChatCartContainerExit = "_cx-4";
export var aiChatContainerLarge = "_cx-0";
export var aiChatContainerSmall = "_cx-1";
export var aiChatIcon = "_cx-6";
export var slideInFromRight = "_cx-3";
export var slideOutToRight = "_cx-5";